<template>
  <div>
    <!-- Client MOM Summary Section Start -->
    <div></div>
    <b-button
      v-if="clientID > 0"
      class="mb-1 mt-1"
      @click="viewClientMOM(clientID)"
      size="xs"
      style="font-size: 0.675rem"
      >View MOM</b-button
    >
    <b-modal
      class="modal-dialog-doc"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      ref="ViewMinutesOfMeeting-modal"
      hide-footer
      :title="Page_title"
    >
      <b-row>
        <b-col cols="4" class="pull-right">
          <b-button
            v-if="ClientMOMList.length > 0"
            :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
            @click="getReports('getClientMOMList', 'Export As Excel')"
            size="sm"
            variant="warning"
            style="font-size: 0.675rem"
          >
            {{ ExcelBtnName }}
            <b-spinner
              v-if="ExcelBtnName != 'Export As Excel'"
              small
              label="Small Spinner"
            ></b-spinner
          ></b-button>
        </b-col>
      </b-row>
      <div
        class="accordion"
        role="tablist"
        v-for="(item, index) in ClientMOMList"
        :key="index"
      >
        <b-card no-body class="mb-1">
          <b-card-header
            header-tag="header"
            class="p-1"
            role="tab"
            @click="ActiveAccordion(item.activeStatus, index)"
          >
            <b-row>
              <b-col cols="4">
                <b-button
                  style="font-size: 0.675rem"
                  size="sm"
                  class="text-left"
                  :variant="item.is_followup_done == 0 ? 'warning' : 'info'"
                  >{{ item.meeting_code }}
                </b-button>
              </b-col>
              <b-col cols="4" class="text-center">
                <b-button
                  style="font-size: 0.675rem"
                  size="sm"
                  class="text-left"
                  :variant="item.is_followup_done == 0 ? 'warning' : 'info'"
                  ><b>MOM User : </b>{{ item.mom_user_txt }}</b-button
                >
              </b-col>
              <b-col cols="4" class="text-right">
                <b-button
                  style="font-size: 0.675rem"
                  size="sm"
                  class="text-right"
                  :variant="item.is_followup_done == 0 ? 'warning' : 'info'"
                  >{{ item.mom_datetime }}</b-button
                >
              </b-col>
            </b-row>
          </b-card-header>
          <b-card-body v-if="item.activeStatus">
            <b-card-text
              ><b>MOM Date : </b
              >{{
                item.mom_datetime
              }}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span
                class="text-right"
                ><b-button
                  style="font-size: 0.675rem"
                  size="sm"
                  class="text-left"
                  :variant="item.is_followup_done == 0 ? 'danger' : 'success'"
                  @click="
                    item.is_followup_done == 0
                      ? FollowupDone(
                          item.meeting_code,
                          item.fk_client_id,
                          item.mom_id,
                          item.is_followup_done == 0 ? 1 : 0
                        )
                      : ''
                  "
                  >{{
                    item.is_followup_done == 0 ? "Followup Pending" : "Followup Done"
                  }}</b-button
                >
                <!-- <AddClientMOM
                  v-if="PMC_ClientID"
                  :PMC_title="'Edit Client MOM - ' + PMC_ClientName"
                  :PMC_ClientID="PMC_ClientID"
                  :PMC_ClientName="PMC_ClientName"
                  :PMC_ClientEmail="PMC_ClientEmail"
                  :PMC_ClientPhone="PMC_ClientPhone"
                  :PMC_ClientSeries="PMC_ClientSeries"
                  :PMC_Filter="PMC_Filter"
                  :PMC_mom_id="item.mom_id"
                  :PMC_mom_Data="item"
                /> -->
              </span>
            </b-card-text>
            <b-card-text><b>Pridel User : </b>{{ item.mom_pridel_user }}</b-card-text>
            <b-card-text><b>MOM User : </b>{{ item.mom_user }}</b-card-text>
            <b-card-text><b>Other User : </b>{{ item.other_mom_user_name }}</b-card-text>
            <b-card-text><b>MOM Venue : </b>{{ item.mom_venue }}</b-card-text>
            <b-card-text
              ><b>Minutes Of Meeting : </b
              ><span
                v-for="(line, lineNumber) of item.mom_minutes_of_meeting.split('\n')"
                v-bind:key="lineNumber"
              >
                <p v-html="line">{{ line }}</p>
                <br /> </span
            ></b-card-text>
            <b-card-text
              ><b>Further Action : </b>{{ item.mom_further_action }}</b-card-text
            >
            <b-card-text><b>Followup Date : </b>{{ item.mom_followupdate }}</b-card-text>
            <b-card-text><b>Followup Time : </b>{{ item.mom_followup_time }}</b-card-text>
            <b-card-text><b>Assign To : </b>{{ item.assigned_user_txt }}</b-card-text>
            <b-card-text
              ><b>Remark : </b
              ><span
                v-for="(lRemark, rindex) of item.mom_remark.split('\n')"
                v-bind:key="rindex"
              >
                {{ lRemark }}<br /> </span
            ></b-card-text>
          </b-card-body>
        </b-card>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="hideClientMOMModal"
        >Close
      </b-button>
    </b-modal>
  </div>

  <!-- Client MOM  Summary Section End -->
</template>

<script>
import CustomLoader from "../common/customLoader.vue";
import ClientMomService from "../../services/ClientMomService.js";
// import AddClientMOM from "./clientMOM.vue";

export default {
  props: {
    PMC_title: {
      type: String,
      default: "",
    },
    PMC_ClientID: {
      type: String,
      default: "",
    },
    PMC_ClientName: {
      type: String,
      default: "",
    },
    PMC_ClientEmail: {
      type: String,
      default: "",
    },
    PMC_ClientPhone: {
      type: String,
      default: "",
    },
    PMC_ClientSeries: {
      type: String,
      default: "",
    },
    PMC_Filter: {
      type: Object,
      default: {},
    },
  },
  beforeMount() {
    if (this.PMC_ClientID) {
      // this.viewClientMOM();
    }
  },
  mounted() {},

  data() {
    return {
      ExcelBtnName: "Export As Excel",
      Page_title: this.PMC_title,
      ClientMOMList: [],
      clientID: this.PMC_ClientID,
      isLoading: false,
      StatusList: [
        {
          DVal: "0",
          DText: "In-ACtive",
        },
        {
          DVal: "1",
          DText: "Active",
        },
        {
          DVal: "2",
          DText: "All",
        },
      ],
      Filter: {
        clientFilter: this.PMC_ClientID,
        momCodeFilter: "",
        commonFilter: "",
        createdUserFilter: "",
        updatedUserFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
    };
  },

  mounted() {},
  filters: {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    CustomLoader,
    // AddClientMOM,
  },

  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.viewClientMOMList("Normal");
      },
      deep: true,
    },
  },
  methods: {
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    filterClear() {
      this.Filter = {
        clientFilter: this.PMC_ClientID,
        momCodeFilter: "",
        commonFilter: "",
        createdUserFilter: "",
        updatedUserFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
      this.viewClientMOMList("Normal");
    },
    FollowupDone(meeting_code, fk_client_id, mom_id, is_followup_done) {
      if (fk_client_id && mom_id) {
        this.isLoading = true;
        let payload = {
          itemCode: "UpdateFollowup",
          meeting_code: meeting_code,
          is_followup_done: is_followup_done,
          mom_id: mom_id,
          fk_client_id: fk_client_id,
        };
        if (this.validate != false) {
          ClientMomService.getAllClientMomList(payload)
            .then((response) => {
              const { data, status, statusText } = response;
              this.isLoading = false;
              this.viewClientMOMList("Normal");
              this.hideClientMOMModal();
            })
            .catch((error) => {
              console.log("Catch on View_MinutesOfMeetingList Error: ", error);
            });
        }
      }
    },
    ActiveAccordion(activeStatus, index) {
      let flag = !activeStatus;
      // Update the activeStatus of the selected index
      this.$set(this.ClientMOMList[index], "activeStatus", flag);
      // Set all other elements' activeStatus to false
      this.ClientMOMList.forEach((element, index2) => {
        if (index2 != index) {
          this.$set(this.ClientMOMList[index2], "activeStatus", false);
        }
      });

      // this.ClientMOMList[index]["activeStatus"] = flag;
      // this.ClientMOMList.forEach((element, index2) => {
      //   if (index2 != index) {
      //     element.activeStatus = false;
      //   }
      // });
      console.log("this.ClientMOMList=>", this.ClientMOMList);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.viewClientMOMList("Excell");
    },
    viewClientMOMList(type) {
      this.PMC_Filter.clientIdFilter = this.clientID;
      this.ClientMOMList = [];
      let payload = {};
      if (this.clientID) {
        if (type == "Normal") {
        this.isLoading = true;
      }

        this.Filter.clientFilter = this.PMC_ClientID;
        payload = {
          itemCode: "getClientMOMList",
          clientID: this.PMC_ClientID,
          clientName: this.PMC_ClientName,
          Filter: this.Filter,
          type:type,
        };

        ClientMomService.getAllClientMomList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (type == "Excell") {
                if (data.getClientMomList.length > 0) {
                  this.ClientMOMList = data.getClientMomList;
                }
                this.ExcelBtnName = "Export As Excel";
                window.location.href =
                  `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
              } else {
                if (data.getClientMomList.length > 0) {
                  this.ClientMOMList = data.getClientMomList;
                }
              }
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on ClientMOMList Error: ", error);
          });
      }
    },

    viewClientMOM(clientID) {
      this.ClientMOMList = [];
      this.$refs["ViewMinutesOfMeeting-modal"].show();
      this.viewClientMOMList("Normal");
    },
    hideClientMOMModal() {
      this.ClientMOMList = [];
      this.$refs["ViewMinutesOfMeeting-modal"].hide();
    },
  },
};
</script>
<style>
.my-custom-scrollbar {
  position: relative;
  height: 550px;
  overflow: auto;
}
.my-custom-scrollbar_xAxis {
  position: relative;
  height: 340px;
  overflow: auto;
}
.table-wrapper-scroll-y {
  display: block;
}
</style>



// WEBPACK FOOTER //
// viewClientMOM.vue?09104187